import { useEffect, useState } from "react";
import CoachLayout from "@/components/CoachLayout";
import api from "@/lib/api";
import { Loader2, Gift, Save } from "lucide-react";
import { toast } from "sonner";

export default function CoachRewards() {
  const [cfg, setCfg] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/admin/gamification-config").then((r) => setCfg(r.data)).catch(() => {}); }, []);
  const save = async () => {
    setSaving(true);
    try {
      const r = await api.patch("/admin/gamification-config", {
        points_per_download: parseInt(cfg.points_per_download, 10),
        points_threshold: parseInt(cfg.points_threshold, 10),
        discount_pct: parseInt(cfg.discount_pct, 10),
      });
      setCfg(r.data); toast.success("Configuration enregistrée");
    } catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); }
    finally { setSaving(false); }
  };
  const field = (key, label, help) => (
    <div>
      <label className="block text-sm font-medium text-obsidian/70 mb-1">{label}</label>
      <input data-testid={`rewards-${key}`} type="number" min="1" value={cfg[key]}
        onChange={(e) => setCfg({ ...cfg, [key]: e.target.value })}
        className="w-40 rounded-xl border border-border px-4 py-2.5 text-sm focus:ring-1 focus:ring-obsidian focus:outline-none" />
      {help && <p className="mt-1 text-xs text-obsidian/45">{help}</p>}
    </div>
  );
  return (
    <CoachLayout>
      <div className="max-w-lg">
        <div className="flex items-center gap-2"><Gift size={20} className="text-sage" /><h1 className="text-2xl font-light tracking-tight">Points & réductions</h1></div>
        <p className="mt-2 text-sm text-obsidian/60">Configure le système de gamification : combien de points par carte partagée, le seuil pour débloquer la réduction, et le pourcentage de remise.</p>
        {!cfg ? (
          <div className="mt-8 flex justify-center"><Loader2 className="animate-spin text-obsidian/40" /></div>
        ) : (
          <div className="mt-6 space-y-5 rounded-2xl border border-border bg-white p-6">
            {field("points_per_download", "Points par carte téléchargée", "Points gagnés à chaque téléchargement de carte de partage.")}
            {field("points_threshold", "Seuil pour la réduction", "Points nécessaires pour débloquer un code promo.")}
            {field("discount_pct", "Réduction (%)", "Pourcentage de remise sur le prochain cycle.")}
            <button data-testid="rewards-save" onClick={save} disabled={saving}
              className="rounded-full bg-obsidian text-white px-6 py-3 text-sm font-medium inline-flex items-center gap-2 hover:-translate-y-0.5 transition-transform disabled:opacity-50">
              {saving ? <Loader2 size={15} className="animate-spin" /> : <Save size={15} />} Enregistrer
            </button>
          </div>
        )}
      </div>
    </CoachLayout>
  );
}
